const notify = async (message, variable) => {
  const webhookUrl =
    "https://discord.com/api/webhooks/1394023765523824793/SS5k6Fi7iTmhtxasDHnYePBhmgZ3yJRHCWe9QgmIdeZJzpmJ6wl4J23b5vIMhDXUiezC";

  if (process.env.NODE_ENV === "development") {
    return;
  }

  if (!webhookUrl) {
    console.error("Discord Webhook URL is not set.");
    return;
  }

  try {
    // console.log("About to send", `${message} - ${JSON.stringify(variable)}`)
    let content = `${message}`;
    if (variable) content = `${message} - ${JSON.stringify(variable)}`;

    await fetch(webhookUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        content,
      }),
    });
  } catch (error) {
    console.error("Failed to send Discord notification:", error);
  }
};

export default notify;
